import templateEdit from './edit/template.html';
import controllerEdit from './edit';
import templateUpload from './upload/template.html';
import controllerUpload from './upload';
import templatePut from './put/template.html';
import controllerPut from './put';

import controllerGet from './get';
import templateGet from './get/template.html';

const usersOnboardHours = {
  url: '/hours',
  stateName: 'Onboard Hours',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: templatePut,
      controller: controllerPut,
      controllerAs: 'userCertificatePutCtrl'
    }
  }
};

const usersCertificates = {
  url: '/certificates',
  stateName: 'CPE Certificates',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/users/certificates')
  },
  views: {
    'a@app': {
      template: templateGet,
      controller: controllerGet,
      controllerAs: 'userCertificatesGetCtrl'
    }
  }
};

const usersCertificatesCertificateEditState = {
  url: '/:certId/edit?source',
  stateName: 'Edit Certificate',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/certificates/:certId/edit')
  },
  params: {
    source: {
      value: undefined,
      squash: true
    }
  },
  views: {
    'a@app': {
      template: templateEdit,
      controller: controllerEdit,
      controllerAs: 'userCertificateEditCtrl'
    }
  }
};

const usersCertificatesCertificateUploadState = {
  url: '/upload',
  stateName: 'Upload Certificate',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass =>
      ResolveClass.authenticateCompany('/certificates/:certId/edit/upload')
  },
  views: {
    'a@app': {
      template: templateUpload,
      controller: controllerUpload,
      controllerAs: 'userCertificateUploadCtrl'
    }
  }
};

const usersCertificatesCertificatePutState = {
  url: '/hours?tour',
  stateName: 'Add Hours',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/certificates/hours')
  },
  params: {
    source: {
      value: undefined,
      squash: true
    }
  },
  views: {
    'a@app': {
      template: templatePut,
      controller: controllerPut,
      controllerAs: 'userCertificatePutCtrl'
    }
  }
};

export {
  usersOnboardHours,
  usersCertificates,
  usersCertificatesCertificateEditState,
  usersCertificatesCertificatePutState,
  usersCertificatesCertificateUploadState
};



// WEBPACK FOOTER //
// ./src/app/controllers/users/certificates/index.js